export default __webpack_public_path__ + "static/trailblazer-4aeadde759b9e2b434c9053baa9f3d1c.png";